import { CogniteLogo } from '#core/components/CogniteLogo';

import classes from './AdnocLogo.module.css';
import AdnocLogoIcon from '#assets/adnoc-logo-icon.svg?react';

export function AdnocLogo() {
  return (
    <div className={classes.logos}>
      <AdnocLogoIcon className={classes.adnocLogoIcon} />
      <CogniteLogo />
    </div>
  );
}
